import React from "react";

export default function PillveryButton(props) {
    return (
        <button
            style       = { props.style }
            className   = { props.class || "btn btn-outline-primary btn-fw"}
            disabled    = { props.disabled }
            onClick     = { props.onClick }
            type        = "button"
        >
            { props.label || "submit"}
        </button>
    )
}